import { render } from "./LoadingSpinnerNr3.vue?vue&type=template&id=2db7f7cd&scoped=true"
import script from "./LoadingSpinnerNr3.vue?vue&type=script&lang=js"
export * from "./LoadingSpinnerNr3.vue?vue&type=script&lang=js"

import "./LoadingSpinnerNr3.vue?vue&type=style&index=0&id=2db7f7cd&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db7f7cd"]])

export default __exports__